"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableGroupHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Cell_1 = require("./Cell");
const Row_1 = require("./Row");
const constants_1 = require("../../constants");
const Checkbox_1 = require("../Checkbox");
const Div_1 = require("../Div");
const Flex_1 = require("../Flex");
const Row = (0, styled_1.default)(Row_1.TableRow)({
    borderBottom: constants_1.theme.border.style.thinLight,
    borderTop: constants_1.theme.border.style.thinLight,
    background: constants_1.Color.BACKGROUND_GREY,
});
const TableGroupHeader = ({ label, children, checkbox, colSpan, }) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Row, { children: (0, jsx_runtime_1.jsx)(Cell_1.TableCell, { colSpan: colSpan, children: (0, jsx_runtime_1.jsxs)(Flex_1.Flex, { gap: 3.5, items: "center", children: [checkbox ? ((0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { checked: checkbox.checked, onChange: checkbox.onCheckedChanged, size: "sm" })) : ((0, jsx_runtime_1.jsx)(Div_1.Div, { styles: { width: 16 } })), label] }) }) }), children] }));
};
exports.TableGroupHeader = TableGroupHeader;
